<template>
  <v-container fluid text-xs-center v-if="selectedCook" style="height: 80vh" class="d-flex justify-center align-center">
    
    <div>
    <!-- <cook :loading="loading" :cooks="cooks" /> -->
    <v-layout row>
      <v-dialog v-model="loading" persistent fullscreen>
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular indeterminate :size="70" :width="7" color="secondary"></v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>

    <v-layout column align-center>
      <v-flex xs12 sm6>
        <v-layout row>
          <v-flex my-10>
          <h1 class="text-center cook_name">{{selectedCook.name}}</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout align-center column>
      <v-flex xs12 sm6>
        <v-layout row>
          <v-flex ma-2>
            <v-btn color="#EFAA42" @click="goToCook(selectedCook.id)">طريقة التحضير</v-btn>
          </v-flex>
       
          <v-flex ma-2>
            <v-btn color="#EFAA42" justify-center @click="handleGetCooks">طبخة أخرى</v-btn>            
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex ma-2>
            <v-dialog v-model="dialog" scrollable max-width="300px">
              <template v-slot:activator="{ on }">
                <v-btn color="#EFAA42" v-on="on">حسب المكونات</v-btn>
              </template>
              <v-card>
                <v-card-title>المكونات</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;" v-if="ingredientCategories">
                  
                  <v-list>
                    <v-list-group
                      v-for="ingcat in ingredientCategories"
                      :key="ingcat.id"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <v-list-item-title v-text="ingcat.name"></v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <v-list-item v-for="ing in ingcat.ingredient" :key="ing.name" class="ma-0 px-4" style="height:50px">
                        <v-list-item-content class="ma-0">
                            <v-checkbox class="mx-2" :key="ing.id" v-model="selected" :label="ing.name" :value="ing.name"></v-checkbox>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                  
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="dialog = false">إغلاق</v-btn>
                  <v-btn color="blue darken-1" text @click="handleIngredients">اختيار</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>          
          </v-flex>

          <v-flex ma-2>
            <v-btn color="#EFAA42" to="/cook/add">إضافة طبخة</v-btn>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

</div>

  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {GET_INGREDIENTS} from '../graphql/Ingredients'
  import {GET_INGREDIENT_CATEGORIES} from '../graphql/IngredientCategories'

  import Cook from '../components/Shared/Cook.vue'


  export default {
    name: 'home',
    data () {
      return {
        dialogm1: '',
        dialog: false,
        selected: []
      }
    },
    apollo: {
      ingredientCategories: {
        query: GET_INGREDIENT_CATEGORIES
      },
      ingredients: {
        query: GET_INGREDIENTS
      }
    },
    created() {
      this.handleGetCooks()
    },
    components: {
      'cook': Cook
    },
    computed: {
      ...mapGetters(['loading', 'selectedCook'])
    },
    methods: {
      handleGetCooks() {
        this.$store.dispatch('getCooks')
      },
      handleIngredients() {
        this.$store.dispatch('selectByIngrdients', this.selected)
      },
      goToCook(cookId) {
        this.$router.push(`/cooks/${cookId}`)
      }
    }

  }
</script>


<style scoped>
  .cook_name {
    font-size: 4em;
  }
</style>